import ROUTES from "const/routes";
import EmailVerificationPage from "pages/EmailVerification/VerificationId/page/email-verification.page";
import ForgotPassword from "pages/ForgotPassword/page/forgot-password.page";
import { LandingPage } from "pages/Landing/page/landing.page";
import GoogleRedirect from "pages/Oauth/Google/Redirect/page/google-redirect.page";
import ResetPassword from "pages/PasswordReset/RequestId/page/reset-password.page";
import SamlRedirect from "pages/Saml/Redirect/page/saml-redirect.page";
import SignIn from "pages/SignIn/page/sign-in.page";
import SignInWithSaml from "pages/SignInWithSaml/page/sign-in-with-saml.page";
import SignUp from "pages/SignUp/page/sign-up.page";
import SignUpNewCompanyAdmin from "pages/SignUpNewCompanyAdmin/page/sign-up-new-company-admin.page";
import { useFeature } from "providers/FeaturesProvider";
import { Navigate, Route, Routes } from "react-router-dom";
import SignUpEmployee from "../pages/SignUpEmployee/page/sign-up-employee.page";
import { AdminRoutes } from "./AdminRoutes";
import { EmployeeRoutes } from "./EmployeeRoutes";
import { LanguageLayout } from "./LayoutLang";
import { Reception } from "./Reception";

const AppRoutes = () => {
  const isSAMLEnabled = useFeature("saml_feature");
  return (
    <Routes>
      <Route element={<LanguageLayout />} path="/:language?/*">
        <Route element={<SignIn />} path={ROUTES.SIGN_IN} />
        <Route element={<LandingPage />} path="landing" />
        {isSAMLEnabled && (
          <Route element={<SignInWithSaml />} path={ROUTES.SIGN_IN_WITH_SAML} />
        )}
        <Route element={<SignUp />} path={ROUTES.SIGN_UP} />
        <Route
          element={<SignUpNewCompanyAdmin />}
          path={ROUTES.SIGN_UP_NEW_COMPANY_ADMIN}
        />
        <Route element={<SignUpEmployee />} path={ROUTES.SIGN_UP_EMPLOYEE} />
        <Route element={<ForgotPassword />} path={ROUTES.PASSWORD_FORGOTTEN} />
        <Route element={<ResetPassword />} path={ROUTES.PASSWORD_RESET} />
        <Route element={<GoogleRedirect />} path={ROUTES.GOOGLE_REDIRECT} />
        <Route element={<SamlRedirect />} path={ROUTES.SAML_REDIRECT} />
        <Route
          element={<EmailVerificationPage />}
          path={ROUTES.EMAIL_VERIFICATION}
        />
        <Route element={<Reception />}>
          <Route index element={<Navigate to="admin" replace />} />
          <Route element={<AdminRoutes />} path="admin/*" />
          <Route element={<EmployeeRoutes />} path="employee/*" />
          <Route element={<Navigate to="admin" replace />} path="*" />
        </Route>
      </Route>
    </Routes>
  );
};
export default AppRoutes;
